export const paymentAccountExists = obj => {
    if (!obj) {
        return false;
    }

    return obj.hasOwnProperty('id') && typeof obj.id === 'string' && obj.id.startsWith('cus');
};
